export type BrowseItemCount = {
    numberFound: number;
    maxNumberFound: number;
};

let lastBrowseItemCount: BrowseItemCount | null = null;

export const setLastBrowseItemCount = (numberFound: number, maxNumberFound: number): void => {
    lastBrowseItemCount = { numberFound, maxNumberFound };
};

export const getLastBrowseItemCount = (): BrowseItemCount | null => lastBrowseItemCount;

export const clearLastBrowseItemCount = (): void => {
    lastBrowseItemCount = null;
};
